import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const LoginCallback = () => {
  const { session, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading) {
      if (session) {
        const params = new URLSearchParams(location.search);
        const returnUrl = params.get('returnUrl') || 'https://verifier.psingletary.com/verifier';
        // Use window.location so an absolute returnUrl (e.g. https://verifier.psingletary.com/verifier) works.
        window.location.replace(returnUrl);
      } else {
        navigate('/login', { replace: true });
      }
    }
  }, [session, loading, navigate, location]);

  if (loading) return <p>Processing login...</p>;

  return <p>Completing login...</p>;
};

export default LoginCallback;
